export default "__VITE_ASSET__PbDeZjmK__"